import { PortalDialogProps } from "@app/services/modal.service";
import Modal from "../modal/modal.component";
import Button from "../button";
import { FormControl } from "../form-control";
import Input from "../input";
import { Form, Formik, FormikContextType } from "formik";
import { createRef, useEffect } from "react";
import { SqlTemplate } from "@app/types/sql-templates.type";
import { createSqlTemplateValidationSchema } from "@app/validations/sql-template.validation";
import TextArea from "../textarea";

interface SqlTemplateModalProps {
  sqlTemplate: SqlTemplate;
}

function SqlTemplateModal({
  portalDialogRef,
  portalData,
}: PortalDialogProps<SqlTemplateModalProps>) {
  const formRef = createRef<
    FormikContextType<{
      name: string;
      sqlStatement: string;
    }>
  >();

  const onSubmit = (values: { name: string; sqlStatement: string }) => {
    if (!formRef.current) return;

    const sqlTemplate = {
      name: values.name,
      sqlTemplate: values.sqlStatement,
    };

    portalDialogRef.close({ sqlTemplate });
  };

  useEffect(() => {
    if (portalData?.sqlTemplate && formRef.current) {
      formRef.current.setValues({
        name: portalData.sqlTemplate.name,
        sqlStatement: portalData.sqlTemplate.sqlStatement,
      });
    }
  }, [portalData?.sqlTemplate]);

  return (
    <Modal onCancel={portalDialogRef.close}>
      <div className="w-[423px] py-7 px-6">
        <div className="text-black font-semibold text-xl">Chỉnh sửa</div>
        <Formik
          innerRef={formRef}
          initialValues={{
            name: "",
            sqlStatement: "",
          }}
          onSubmit={onSubmit}
          validationSchema={createSqlTemplateValidationSchema}
          validateOnChange
          validateOnBlur
        >
          <Form>
            <FormControl name="name">
              <Input className="mt-7" placeholder="Tên template" />
            </FormControl>
            <FormControl name="sqlStatement">
              <TextArea
                textAreaClassName="bg-color border-none outline-none rounded-lg !px-4 !py-3"
                className="mt-6"
                width="100%"
                height="auto"
                rows={5}
                placeholder="SQL template"
              />
            </FormControl>
            <div className="mt-11 flex justify-center gap-4">
              <Button
                size="xs"
                label="Hủy"
                theme="secondary"
                width={180}
                className="!h-[51px] !leading-[51px]"
                labelClassName="text-xl"
                onClick={portalDialogRef.close}
              />
              <Button
                type="submit"
                size="xs"
                label="Lưu"
                width={180}
                className="!h-[51px] !leading-[51px]"
                labelClassName="text-xl"
              />
            </div>
          </Form>
        </Formik>
      </div>
    </Modal>
  );
}

export default SqlTemplateModal;
